/**
 * 设备信息组件
 */
// import Core from '@/libs/src/core.js'
import { Style } from '@/libs/style.js';

// 获取数据处理层的provider
let DPC// = Core.getProvider('DPC');
let modules //= DPC.modules;

let template = /*html*/ `<div class="app-monitoring">
    <div class="app-monitoring-header">
        <!--<img src="./images/default/2.png" alt="">-->
        <h2>水场信息</h2>
        <dv-decoration-1 style="width:200px;height:100%;position:absolute;right:0;" />
        <img src="@/assets/default/border-botoom.png" style="width:99%;height:auto;position:absolute;bottom:0;left:-15px;" alt="" srcset="">
    </div>
    
    <dv-scroll-board-1 :config="JSON.stringify(config)" ></dv-scroll-board-1>
</div>`;


let style = /* css */ `.app-monitoring{
    position: absolute;
    top: 33%;
    left: 1%;
    width: 25%;
    background: rgba(0,0,0,0.2);
    height: 30%;
    overflow: hidden;
}

.app-monitoring .app-monitoring-header{
    padding-left:15px;
    background:linear-gradient(to right,#159AFF80,rgba(0,0,0,0) 100%);
    height: 50px;
    color: #fff;
    display:flex;
    align-items:center;
    position:relative;
}
.app-monitoring .app-monitoring-header img{
    margin:0 15px;
}
`;

export default (Vue) => {
    Vue.customElement('xbt-app-monitoring', {
        template: template,
        data() {
            return {
                config: {
                    oddRowBGC: 'rgba(0,0,0,0)',
                    evenRowBGC: 'rgba(0,0,0,0)',
                    rowNum:6,
                    data: [
                        ['好氧池液位浮球开关当前值','低'],
                        ['系统运行工况','正常'],
                        ['设备间系统温度','42℃'],
                        ['系统当前有功功率','2389.8W'],
                        ['系统当前有功电能','101117.47kW·h'],
                        ['设备间系统湿度','22%'],

                        ['风机风量','22%'],
                        ['泥位计高低','22%'],
                        ['好氧池浮球液位','22%'],
                        ['缺氧池浮球液位','22%'],
                        ['厌氧池浮球液位','22%'],
                        ['集水池液位计','22%'],
                        ['内回流量','22%'],
                        ['外回流量','22%'],
                        ['高密池回流量','22%'],
                    ],
                    align: ['left','right'],
                    
                }
            }
        },
        created() {
            DPC = this.$Core.getProvider('DPC');
            modules = DPC.modules;
            if (!modules) {
                DPC.proc.watch('modules', (val) => {
                    let monitor = val.filter(item => item.showType === 'monitor' || item.showType === 'enum');
                    this.setList(monitor)
                })
            } else {
                let monitor = modules.filter(item => item.showType === 'monitor' || item.showType === 'enum');
                this.setList(monitor)
            }
        },
        mounted() {
            Style(style);
        },
        methods: {
            setList(val) {

                val.forEach(item => {
                    let unit = item.unit.length > 1 ? item.unit[1] : '';
                    let displayValue = Number(item.displayValue) ? Number(item.displayValue).toFixed(2) : item.displayValue;
                    let itemArr = [item.className, item.controlName, displayValue + ' ' + unit];
                    // this.config.data.push(itemArr)
                })
            }
        }
    });
}